var billingAddressRadioBtn = document.querySelectorAll('.jsBillingAddress');
var paymentMethodRadioBtn = document.querySelectorAll('.jsChangePayment');
var checkoutQtyTextbox = document.querySelectorAll('.jsChangeQuantityItemCheckout');
var vatNumberTextbox = document.querySelectorAll('.vatnumber');

var addReturnProductCheckox = document.querySelectorAll('.jsAddReturnProduct');
for (var c = 0; c < addReturnProductCheckox.length; c++) {
    addReturnProductCheckox[c].onclick = addReturnProduct;
}

var shippingAddressRadio = document.querySelectorAll('.jsSingleAddress');

var selectedAddressDdl = document.querySelectorAll('.js-select-shippingaddress');
for (var i = 0; i < selectedAddressDdl.length; i++) {
    selectedAddressDdl[i].onchange = selectedAddressChange;
}

var selectedBillingAddressDdl = document.querySelectorAll('.js-select-billingaddress');
for (var x = 0; x < selectedBillingAddressDdl.length; x++) {
    selectedBillingAddressDdl[x].onchange = selectedBillingAddressChange;
}

for (var vat = 0; vat < vatNumberTextbox.length; vat++) {
    vatNumberTextbox[vat].onchange = vatnumberchange;
}

for (var s = 0; s < shippingAddressRadio.length; s++) {
    shippingAddressRadio[s].onchange = shippingAddressChange;
}

function selectedAddressChange(event) {
    var el = this;
    var value = el.value;
    var url = el.getAttribute('data-url');

    fetch(url + '?addressId=' + value, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(function (res) {
            return res.text();
        })
        .then(function (html) {
            var div = document.querySelector('#selectedShippingAddress');
            div.innerHTML = html;

            initCouponRemove();
            initCouponToggle();
        })
        .catch(function (err) {
            console.log(err);
        });
}

function selectedBillingAddressChange(event) {
    var el = this;
    var value = el.value;
    var url = el.getAttribute('data-url');

    fetch(url + '?addressId=' + value, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(function (res) {
            return res.text();
        })
        .then(function (html) {
            var div = document.querySelector('#selectedBillingAddress');
            div.innerHTML = html;

            initCouponRemove();
            initCouponToggle();
        })
        .catch(function (err) {
            console.log(err);
        });
}

function shippingAddressChange(event) {
    var el = this;
    var shippingRow = findAncestor(this, 'jsShippingAddressRow');
    var value = el.value;

    if (value == 0) {
        shippingRow.getElementsByClassName('jsOldShippingAddressForm')[0].classList.add('hidden');
        shippingRow.getElementsByClassName('jsNewShippingAddressForm')[0].classList.remove('hidden');
    } else {
        shippingRow.getElementsByClassName('jsOldShippingAddressForm')[0].classList.remove('hidden');
        shippingRow.getElementsByClassName('jsNewShippingAddressForm')[0].classList.add('hidden');
    }
}

function initCouponToggle() {
    var couponAddBtn = document.querySelectorAll('.jsAddCoupon');

    for (var i = 0; i < couponAddBtn.length; i++) {
        couponAddBtn[i].onclick = addCoupon;
    }

    var _toggles = document.querySelectorAll('.js-coupons');

    for (var t = 0; t < _toggles.length; t++) {
        _toggles[t].addEventListener('click', function () {

            // Get taget from attribute
            var targetId = this.dataset.target;

            // Get closest parent
            var parent = this.parentElement.closest('.discountcode');

            // Find the toggle target
            var target = parent.querySelector(`#${targetId}`);
            if (!target.classList.contains('is-active')) {
                this.classList.add('is-open');
                target.classList.add('is-active');
                target.style.height = 'auto';
                var height = `${target.clientHeight + 20}px`;
                target.style.height = '0px';
                setTimeout(() => {
                    target.style.height = height;
                }, 0);
            } else {
                this.classList.remove('is-open');
                target.style.height = '0px';
                target.classList.remove('is-active');

            }
        });
    }
}







function initCouponRemove() {
    var removeBtn = document.querySelectorAll('.jsRemoveCoupon');

    for (var i = 0; i < removeBtn.length; i++) {
        removeBtn[i].onclick = removeCoupon;
    }
}

initCouponToggle();
initCouponRemove();

for (var b = 0; b < billingAddressRadioBtn.length; b++) {
    billingAddressRadioBtn[b].onclick = billingAddressToggle;

}

for (var p = 0; p < paymentMethodRadioBtn.length; p++) {
    paymentMethodRadioBtn[p].onclick = paymentMethodToggle;
}

for (var c = 0; c < checkoutQtyTextbox.length; c++) {
    checkoutQtyTextbox[c].onchange = checkoutChangeQuantity;
}



function addCoupon(event) {
    event.preventDefault();

    var form = findAncestor(this, 'discountcode__body');
    var action = form.getAttribute('data-action');
    var couponField = form.getElementsByClassName('jsCouponCode')[0];
    var errorField = form.getElementsByClassName('invaliderror')[0];
    var code = couponField.value;

    var paymentBlock = document.querySelector('#paymentBlock');

    var data = {
        couponCode: code
    };

    fetch(action, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(function (result) {
            if (result.status !== 200) {
                errorField.style.display = "block";
            }

            return result.text();
        })
        .then(function (html) {
            //Re-bind selects
            if (html !== "") {
                paymentBlock.innerHTML = html;

                updatePlacedPrices();

                var paymentMethodRadioBtn = document.querySelectorAll('.jsChangePayment');

                for (var p = 0; p < paymentMethodRadioBtn.length; p++) {
                    if (paymentMethodRadioBtn[p]) {
                        paymentMethodRadioBtn[p].onclick = paymentMethodToggle;
                    }
                }

                var cartSummaryBlock = document.querySelector('.cart-summary__body');
                var jsOrderSummaryInPayment = document.querySelector('.jsOrderSummaryInPayment');
                cartSummaryBlock.innerHTML = jsOrderSummaryInPayment.innerHTML;

                var checkoutProductOptionsBlock = document.querySelector('#checkout-retour-controls');
                var jsProductOptionsInPayment = document.querySelector('.jsProductOptionsInPayment');
                checkoutProductOptionsBlock.innerHTML = jsProductOptionsInPayment.innerHTML;

                initCouponRemove();
                initCouponToggle();
            }
        })
        .catch(function (err) {
            console.log(err);
        });
}

function removeCoupon(event) {
    event.preventDefault();

    var el = this;
    var code = el.getAttribute('data-couponcode');
    var action = el.getAttribute('data-action');

    var paymentBlock = document.querySelector('#paymentBlock');

    var data = {
        couponCode: code
    };

    fetch(action, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(function (res) {
            return res.text();
        })
        .then(function (html) {
            //Re-bind selects
            paymentBlock.innerHTML = html;

            updatePlacedPrices();

            var paymentMethodRadioBtn = document.querySelectorAll('.jsChangePayment');

            for (var p = 0; p < paymentMethodRadioBtn.length; p++) {
                paymentMethodRadioBtn[p].onclick = paymentMethodToggle;
            }

            var cartSummaryBlock = document.querySelector('.cart-summary__body');
            var jsOrderSummaryInPayment = document.querySelector('.jsOrderSummaryInPayment');
            cartSummaryBlock.innerHTML = jsOrderSummaryInPayment.innerHTML;

            var checkoutProductOptionsBlock = document.querySelector('#checkout-retour-controls');
            var jsProductOptionsInPayment = document.querySelector('.jsProductOptionsInPayment');
            checkoutProductOptionsBlock.innerHTML = jsProductOptionsInPayment.innerHTML;

            initCouponToggle();
        })
        .catch(function (err) {
            console.log(err);
        });
}

function initExtraProducts() {
    var addProductCheckox = document.querySelectorAll('.jsAddExtraProduct');
    for (var c = 0; c < addProductCheckox.length; c++) {
        addProductCheckox[c].onclick = addRemoveExtraProduct;
    }
}

initExtraProducts();


function addRemoveExtraProduct(event) {
    event.preventDefault();
    var el = this;

    var url = el.getAttribute('data-url');
    var removeUrl = el.getAttribute('data-remove-url');
    var code = el.getAttribute('data-code');
    var lang = el.getAttribute('data-lang');

    var checked = el.checked;
    var toPostTo = checked ? url : removeUrl;

    var paymentBlock = document.querySelector('#paymentBlock');

        window.fetch(toPostTo, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ code: code, language: lang })
        })
            .then(function (res) {
                return res.text();
            })
            .then(function (html) {

                paymentBlock.innerHTML = html;

                //Re-bind selects
                var paymentMethodRadioBtn = document.querySelectorAll('.jsChangePayment');
                for (var i = 0; i < paymentMethodRadioBtn.length; i++) {
                    paymentMethodRadioBtn[i].onclick = paymentMethodToggle;
                }

                var checkoutProductOptionsBlock = document.querySelector('#checkout-retour-controls');
                var jsProductOptionsInPayment = document.querySelector('.jsProductOptionsInPayment');
                checkoutProductOptionsBlock.innerHTML = jsProductOptionsInPayment.innerHTML;

                initExtraProducts();

                var cartSummaryBlock = document.querySelector('.cart-summary__body');
                var jsOrderSummaryInPayment = document.querySelector('.jsOrderSummaryInPayment');
                cartSummaryBlock.innerHTML = jsOrderSummaryInPayment.innerHTML;
                initCouponRemove();
                initCouponToggle();
                
            })
            .catch(function (err) {
                console.log(err);
            });

}

function paymentMethodToggle(event) {
    var el = this;

    var url = el.getAttribute('data-url');
    var methodId = el.getAttribute('data-methodid');
    var keyword = el.getAttribute('data-keyword');

    var paymentBlock = document.querySelector('#paymentBlock');

    var data = {
        PaymentMethodId: methodId,
        SystemKeyword: keyword,
    };

    fetch(url, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then((res) => res.text())
        .then(function (html) {
            paymentBlock.innerHTML = html;

            //Re-bind selects
            var paymentMethodRadioBtn = document.querySelectorAll('.jsChangePayment');
            for (var p = 0; p < paymentMethodRadioBtn.length; p++) {
                paymentMethodRadioBtn[p].onclick = paymentMethodToggle;
            }
        })
        .catch(function (err) {
            console.log(err);
        });
}


function billingAddressToggle(event) {
    var el = this;
    var value = el.value;

    var oldBillingAddressForm = document.querySelector('#oldBillingAddressForm');
    var newBillingAddressForm = document.querySelector('#newBillingAddressForm');

    if (value === "0") { //New Address
        oldBillingAddressForm.classList.add('hidden');
        newBillingAddressForm.classList.remove('hidden');
    } else if (value === "1") { //Existing address
        oldBillingAddressForm.classList.remove('hidden');
        newBillingAddressForm.classList.add('hidden');
    } else if (value === "2") { //Shipping for billing
        oldBillingAddressForm.classList.add('hidden');
        newBillingAddressForm.classList.add('hidden');
    }
}

function vatnumberchange(event) {
    var el = this;

    var enterednumber = el.value;
    var seturl = el.getAttribute('data-url');
    var paymentBlock = document.querySelector('#paymentBlock');

    var number = enterednumber.replace(/[ ,.]/g, "");
    el.value = number;

    var data = {
        vatNumber: number
    };

    fetch(seturl, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(function (res) {
            return res.text();
        })
        .then(function (html) {

            paymentBlock.innerHTML = html;

            //Re-bind selects
            var paymentMethodRadioBtn = document.querySelectorAll('.jsChangePayment');
            for (var i = 0; i < length; i++) {
                paymentMethodRadioBtn[i].onclick = paymentMethodToggle;
            }

            var cartSummaryBlock = document.querySelector('.cart-summary__body');
            var jsOrderSummaryInPayment = document.querySelector('.jsOrderSummaryInPayment');
            cartSummaryBlock.innerHTML = jsOrderSummaryInPayment.innerHTML;

            var checkoutProductOptionsBlock = document.querySelector('#checkout-retour-controls');
            var jsProductOptionsInPayment = document.querySelector('.jsProductOptionsInPayment');
            checkoutProductOptionsBlock.innerHTML = jsProductOptionsInPayment.innerHTML;

            initCouponRemove();
            initCouponToggle();
        })
        .catch(function (err) {
            console.log(err);
        });
}


function updatePlacedPrices() {
    var paymentBlock = document.querySelector('#paymentBlock');

    var priceFields = document.querySelectorAll('.placedprice');
    var priceFieldsArray = Array.prototype.slice.call(priceFields);

    for (var i = 0; i < priceFieldsArray.length; i++) {
        var code = priceFieldsArray[i].getAttribute('data-code');
        var newPriceField = paymentBlock.querySelector('.placedprice-' + code);
        if (newPriceField !== null) {
            priceFieldsArray[i].innerHTML = newPriceField.innerHTML;
        }
    }
}

function checkoutChangeQuantity(event) {
    var el = this;

    var quantity = parseInt(el.value);
    var code = el.getAttribute('data-code');
    var url = el.getAttribute('data-url');
    var shipmentId = el.getAttribute('data-shipmentid');

    var paymentBlock = document.querySelector('#paymentBlock');

    var data = {
        code: code,
        quantity: quantity,
        shipmentId: shipmentId
    };

    fetch(url, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ code: code, quantity: quantity, shipmentId: shipmentId })
    })
        .then(function (res) {
            return res.text();
        })
        .then(function (html) {
            paymentBlock.innerHTML = html;

            updatePlacedPrices();

            //Re-bind selects
            var paymentMethodRadioBtn = document.querySelectorAll('.jsChangePayment');

            for (var i = 0; i < paymentMethodRadioBtn.length; i++) {
                paymentMethodRadioBtn[i].onclick = paymentMethodToggle;
            }

            var qtyField = paymentBlock.querySelector('.qty-' + code);

            if (qtyField !== null) {
                el.value = qtyField.innerHTML;
            }

            if (quantity === 0 || isNaN(quantity)) {
                var itemRow = findAncestor(el, 'jsCartItem');
                itemRow.parentElement.removeChild(itemRow);
            }

            var cartSummaryBlock = document.querySelector('.cart-summary__body');
            var jsOrderSummaryInPayment = document.querySelector('.jsOrderSummaryInPayment');
            cartSummaryBlock.innerHTML = jsOrderSummaryInPayment.innerHTML;

            var checkoutProductOptionsBlock = document.querySelector('#checkout-retour-controls');
            var jsProductOptionsInPayment = document.querySelector('.jsProductOptionsInPayment');
            checkoutProductOptionsBlock.innerHTML = jsProductOptionsInPayment.innerHTML;

            var updatedQuantity = 0;

            var quantityTotal = document.querySelectorAll('.jsChangeQuantityItemCheckout');

            for (var q = 0; q < quantityTotal.length; q++) {

                if (isNaN(quantityTotal[q].value)) {
                    quantityTotal[q].value = "0";
                }

                updatedQuantity = updatedQuantity + parseInt(quantityTotal[q].value);
            }

            // Update Cart Badge with current Quantity
            updateCartCount(updatedQuantity);

            // With no items in Cart reload the Page to get the Empty Cart View.
            if (updatedQuantity === 0) {
                window.location.reload();
            }

            initCouponRemove();
            initCouponToggle();
        })
        .catch(function (err) {
            console.log(err);
        });
}

function findAncestor(el, cls) {
    while ((el = el.parentElement) && !el.classList.contains(cls));
    return el;
}

function initNotification() {
    var orderConfirmationMessage = document.querySelector('#orderConfirmationMessage');

    if (orderConfirmationMessage !== null) {
        orderConfirmationMessage.style.display = 'block';

        var orderConfirmationCloseBtn = document.querySelector('#orderConfirmationCloseBtn');

        if (orderConfirmationCloseBtn !== null) {
            orderConfirmationCloseBtn.onclick = function (event) { orderConfirmationMessage.style.display = 'none'; };
        }
    }
}

(function () {
    var checkoutForm = document.getElementById("jsCheckoutForm");

    if (checkoutForm !== null && checkoutForm !== undefined) {

        checkoutForm.onsubmit = function () {

            if (document.querySelectorAll(".input-validation-error").length === 0) {

                var orderSubmitButton = document.getElementById("orderSubmitBtn");
                orderSubmitButton.disabled = true;

                var loader = document.getElementById("checkout-loader");
                loader.style.display = "block";
            }

        };
    }

})();

initNotification();